import { useEffect, useState } from 'react'

import logo from '../assets/logo.png'
import { cn } from '../libs/tailwindMerge'
import { HeaderActions } from './HeaderActions'

export function FloatingHeader() {
  const [isSticky, setIsSticky] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      const scrollThreshold = 200
      setIsSticky(window.scrollY > scrollThreshold)
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  function scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  return (
    <div
      className={cn(
        'lg:px-0 transition-all duration-300 fixed top-0 left-0 w-screen bg-slate-50 z-[9999] items-center',
        isSticky
          ? 'flex'
          : 'hidden',
      )}
    >
      <div
        className="flex custom-bottom-shadow justify-between items-center w-full lg:max-w-screen-lg mx-auto p-2"
      >
        <button
          type="button"
          onClick={scrollToTop}
        >
          <img
            src={logo}
            alt="NJF Alimentos"
            className="w-20"
          />
        </button>
        <HeaderActions />
      </div>
    </div>
  )
}
